import { CustomError } from 'components/error/Error';

export default function SitemapXml() {
  return (
    <CustomError code={404}/>
  );
}

export const getServerSideProps = async (ctx) => {
  if (ctx.res) {
    if (!ctx?.req?.state?.customDomain) {
      return {
        props: {},
      };
    }

    const date = new Date();
    // set it to beginning of day
    date.setHours(0, 0, 0, 0);
    ctx.res.setHeader('Content-Type', 'text/xml');
    ctx.res.write(`<?xml version="1.0" encoding="UTF-8"?>
<sitemapindex xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
    <sitemap>
        <loc>https://${ctx.req.headers.host}/main.xml</loc>
        <lastmod>${date.toISOString()}</lastmod>
    </sitemap>
    <sitemap>
        <loc>https://${ctx.req.headers.host}/products.xml</loc>
        <lastmod>${date.toISOString()}</lastmod>
    </sitemap>
</sitemapindex>
`);
    ctx.res.end();
  }
  return {
    props: {},
  };
};
